<div class="flex-parent">
  <div class="login-form-div">
    <app-logo></app-logo>
    <div class="header">
      <h2 class="text-details">
      {{'loginForm.resetMessage' | translate}}
      </h2>
    </div>
    <form class="login-form" [formGroup]="resetForm">
      <bos-reactive-mat-form-password [initFocus]="true" [translateKeyPrefix]="'loginForm.'" [fieldName]="'password'"
                                      [parentFormGroup]="resetForm">
      </bos-reactive-mat-form-password>
      <div class="additional-options">
        <app-back-button></app-back-button>
      </div>

      <button class="left-margin login-button" mat-flat-button color="primary" [disabled]="!resetForm.valid"
              (click)="reset()" type="submit" prevent-double-submit [@inProgress]="inProgress">
        <mat-icon color="accent" class="login-icon">done</mat-icon>
        <app-progress-button
                [progress]="inProgress"
                [success]="success"
                [standardButtonLabel]="'loginForm.resetButton'"
                [successButtonLabel]="'loginForm.resetButton.success'"></app-progress-button>
      </button>

    </form>
  </div>
</div>
